/* eslint-disable camelcase */
import { graphql } from '@/generated/gql/gql'
import { FragmentType, useFragment } from '@/generated/gql'
import { useLocale } from '@/components/Link'
import { getCountryFromLocale } from '@/helpers/multiRegion'
import { getCurrencyCodeForCountry } from '@/helpers/countries'

const canteenMenuUserLocationDataFragment = graphql(`
  fragment CanteenAccountLocation_UserDataFragment on User {
    accountLocation {
      address {
        country
      }
    }
  }
`)

export const useDefaultCurrency = (
  userData?: FragmentType<typeof canteenMenuUserLocationDataFragment>,
) => {
  const locale = useLocale()
  const userLocationData = useFragment(canteenMenuUserLocationDataFragment, userData)

  const countryCode =
    userLocationData?.accountLocation?.address.country?.toLowerCase() ||
    getCountryFromLocale(locale || 'en-gb')
  const currencyForLocaleCountry = getCurrencyCodeForCountry(countryCode) ?? ''

  return currencyForLocaleCountry
}
